import { Cell } from 'common/src/designSystem/components/table/cell';
import { CheckInState, VolunteerRegistrationFragment } from 'common/src/generated/types';
import { getPositionsBadges } from 'common/src/vo/position';
import * as React from 'react';
import { BadgesPlus } from '../../../components/badgesPlus/badgesPlus';

interface IVolunteerRegistrationCheckedInPositionsProps {
    volunteerRegistration: VolunteerRegistrationFragment;

    onClick?(): void;
}

export const VolunteerRegistrationCheckedInPositions = (
    props: IVolunteerRegistrationCheckedInPositionsProps
) => {
    const psuis = React.useMemo(
        () =>
            (props.volunteerRegistration.positionsSlotsUsersInfos || []).filter(
                (psui) => psui.state !== CheckInState.Waiting
            ),
        [props.volunteerRegistration]
    );
    const badges = React.useMemo(() => getPositionsBadges(psuis), [psuis]);

    return (
        <Cell>
            <BadgesPlus badges={badges} doNotSort={true} onClick={props.onClick} />
        </Cell>
    );
};
